import React from 'react'
import styled from 'styled-components'
import fonts from '../../fonts'
import colors from '../../styles/colors'
import breakpoints from '../../styles/breakpoints'
import Wrapper from "../grid/wrapper"
import Row from "../grid/row"
import Column from "../grid/column"
import logoRoca from "../../images/logo-roca.svg"
import FooterSocial from './footerSocial'

const FooterS = styled.footer`
  width: 100%;

  background: ${colors.primary};  
  font-size: 12px;
  font-weight: normal;
  line-height: 18px;
  color: ${colors.tertiary};
  font-family: ${fonts.helvetica};

  a {
      text-decoration: none;
      color: ${colors.tertiary};
      transition: all .4s ease;
    
    :hover {
      text-decoration: underline;
      color: ${colors.primaryLight};
    }
  }
`

const FooterLegal = styled.div`
  margin-top: 15px;
`

const LogoCopy = styled.div`
  display:flex;
  flex-direction: column;
  align-items: flex-start;
`

const FooterLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;

  a{
    flex-grow: 1;
    width: 100%;
    color: #FFFFFF;
    margin-bottom: 15px;

    @media ${breakpoints.tablet} {
      width: 33%;
      margin-bottom: 5px;
    }
  }
`


const Footer = () => {

  return (
    <FooterS>
      <Wrapper>
        <Row>
          <Column sm="6" md="9" mdOffset="1" lgOffset="0">
            <LogoCopy>
              <img alt="Roca - Logo" src={logoRoca} />
              <FooterLinks>
                <a target="_blank" rel="noopener noreferrer" href="http://www.roca.co.id/catalogue/products">Products</a>
                <a target="_blank" rel="noopener noreferrer" href="http://www.roca.co.id/catalogue/collections">Collections</a>
                <a target="_blank" rel="noopener noreferrer" href="http://www.roca.co.id/catalogue/brochure-downloads">General catalogue</a>
                <a target="_blank" rel="noopener noreferrer" href="http://www.roca.co.id/location/points-of-sale">Store locator</a>
                <a target="_blank" rel="noopener noreferrer" href="http://www.roca.co.id/rocalife">Inspiration</a>
                <a target="_blank" rel="noopener noreferrer" href="http://www.roca.co.id/where-to-find-us/exhibition/showrooms-and-galleries/roca-experience-center-indonesia/innovation">Roca Experience Center</a>
                <a target="_blank" rel="noopener noreferrer" href="http://www.roca.co.id/where-to-find-us/contact/contact">Contact</a>
              </FooterLinks>
              <FooterLegal>© Copyright 2020. Roca Sanitario, S.A. - All rights reserved. <a href="http://www.roca.co.id/footer/legal_notice" target="_blank" rel="noopener noreferrer">Legal notice</a>.</FooterLegal>
            </LogoCopy>
          </Column>
          <Column sm="6" md="3">
            <FooterSocial/>
          </Column>
        </Row>
      </Wrapper>
    </FooterS>
  )

}

export default Footer;